import { useMediaQuery } from 'react-responsive';
import { useTheme } from 'styled-components';
import { ArticleCardWithImageVariant } from './AticleCardWithImage';

export function useVariantBasedOnScreenSize(
  variant: ArticleCardWithImageVariant,
) {
  const theme = useTheme();
  const isSmall = useMediaQuery({ maxWidth: theme.breakpointSizes.sm });
  const isMedium = useMediaQuery({
    maxWidth: theme.breakpointSizes.lg,
    minWidth: theme.breakpointSizes.sm,
  });

  const isLarge = useMediaQuery({
    maxWidth: theme.breakpointSizes.xl,
    minWidth: theme.breakpointSizes.lg,
  });

  if (typeof variant !== 'object') return variant;

  if (isSmall) return variant[0];

  if (isMedium) return variant[1];

  if (isLarge) return variant[2];

  return variant[3] || variant[2];
}
